/* eslint-disable react/jsx-closing-tag-location */
/* eslint-disable react/jsx-closing-bracket-location */
import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import FormHelperText from '@material-ui/core/FormHelperText';
import { withTranslation } from 'react-i18next';

import MaskedInputField from '../../Common/MaskedInputField';
import { removeSpecialCharacters, removeCountryCode, getCountryCode, formValidator } from '../../../AppUtil/AppUtil';
import Loader from '../../Common/Loader';
import CountryCodeField from '../../Common/CountryCodeField';
import { hot } from 'react-hot-loader';

const PATTERN = window.AppConfig.REGULAR_EXPRESSION;

const styles = theme => ({
	margin: {
		margin: theme.spacing(1)
	}
});

class EditContactForm extends Component {
	constructor(props) {
		super(props);
		this.state = {
			errorMessage: '',
			_disableContinueButton: true,
			_countryCode: getCountryCode(this.props.currentUser.phone) || '+91',
			_contactInfoForm: {
				phone: {
					value: removeCountryCode(this.props.currentUser.phone) || '',
					placeholder: 'label.contact',
					isValid: false,
					isTouched: false,
					validationRules: {
						isRequired: {
							value: true,
							errorMsg: 'error_message.required_contact'
						},
						pattern: {
							value: PATTERN.CONTACT,
							errorMsg: 'error_message.invalid_contact'
						}
					},
					error_text: ''
				},
				emailId: {
					value: this.props.currentUser.email || '',
					placeholder: 'label.email',
					isValid: false,
					isTouched: false,
					validationRules: {
						isRequired: {
							value: true,
							errorMsg: 'error_message.required_email'
						},
						pattern: {
							value: PATTERN.EMAIL,
							errorMsg: 'error_message.invalid_email'
						}
					},
					error_text: ''
				}
			}
		};
	}

	handleInputChange = e => {
		const name = e.target.name;
		let value = e.target.value;
		this.setState({
			_disableContinueButton: false
		});
		const signUpForm = {
			...this.state._contactInfoForm
		};
		const updatedFormElement = {
			...signUpForm[name]
		};
		if (name === 'phone') {
			value = removeSpecialCharacters(value);
		}
		updatedFormElement.value = value;
		updatedFormElement.isValid = true;
		updatedFormElement.error_text = '';
		signUpForm[name] = updatedFormElement;
		this.setState({
			_contactInfoForm: signUpForm
		});
	};

	formValidator = () => {
		const form = {
			...this.state._contactInfoForm
		};
		const [updatedForm, isFormValid] = formValidator(form);
		this.setState({
			_contactInfoForm: updatedForm
		});
		return isFormValid;
	};

	setCountryCode = e => {
		this.setState({
			_countryCode: e.target.value
		});
	};

	onSubmitHandler = async e => {
		e.preventDefault();
		if (!this.formValidator()) {
			return false;
		}
		const contactDetailForm = {
			...this.state._contactInfoForm
		};
		const countryCode = this.state._countryCode;
		const user = {};
		if (this.props.mode === 'Email') {
			user.email = contactDetailForm.emailId.value;
		} else {
			user.phone = countryCode + contactDetailForm.phone.value;
		}
		const response = await this.props.onSubmit(user);
		if (!response.status) {
			this.setState({
				errorMessage: response.data
			});
		} else {
			this.props.openOtpScreen();
		}
	};

	render() {
		const { t } = this.props;
		return (
			<section>
				<div className="demo-container mdl-grid">
					<div className="mdl-cell mdl-cell--2-col mdl-cell--hide-tablet mdl-cell--hide-phone" />
					<div className="demo-content mdl-color--white mdl-shadow--4dp content mdl-color-text--grey-800 mdl-cell mdl-cell--8-col radius-20 min-250">
						<div className="mdl-grid">
							<div className="mdl-cell mdl-cell--12-col center-items">
								<h4 className="text-center main-top-heading">
									{t('profile.edit_your')}{' '}
									{this.props.mode === 'Email' ? t('label.email_id') : t('label.phone_number')}
								</h4>
							</div>
						</div>
						<div className="mdl-grid center-items">
							<div className="mdl-cell mdl-cell--10-col ">
								<form
									className="text-center"
									onSubmit={e => {
										e.preventDefault();
									}}>
									{this.props.contactDetailMode === 'Email' ? (
										<TextField
											autoComplete="email"
											error={
												!this.state._contactInfoForm.emailId.isValid &&
												this.state._contactInfoForm.emailId.isTouched
											}
											fullWidth
											helperText={(() => {
												if (
													!this.state._contactInfoForm.emailId.isValid &&
													this.state._contactInfoForm.emailId.isTouched
												) {
													return t(this.state._contactInfoForm.emailId.error_text);
												} else {
													return '';
												}
											})()}
											id="email"
											label={t(this.state._contactInfoForm.emailId.placeholder)}
											margin="normal"
											name="emailId"
											onChange={this.handleInputChange}
											value={this.state._contactInfoForm.emailId.value}
											variant="outlined"
										/>
									) : (
										<Grid container justify="center" spacing={0}>
											<Grid item sm={2} xs={3}>
												<CountryCodeField
													setCountryCode={this.setCountryCode}
													value={this.state._countryCode}
												/>
											</Grid>
											<Grid item sm={10} style={{ marginTop: '16px' }} xs={9}>
												<MaskedInputField
													error={
														!this.state._contactInfoForm.phone.isValid &&
														this.state._contactInfoForm.phone.isTouched
													}
													error_text={t(this.state._contactInfoForm.phone.error_text)}
													handleChange={this.handleInputChange}
													label={t(this.state._contactInfoForm.phone.placeholder)}
													value={this.state._contactInfoForm.phone.value}
												/>
											</Grid>
										</Grid>
									)}
									<FormHelperText id="text-red">
										{this.state.errorMessage === '' ? '' : t(this.state.errorMessage)}
									</FormHelperText>
								</form>
							</div>
						</div>
						<div className="mdl-cell mdl-cell--12-col text-center">
							<button
								className="mdl-button mdl-js-button mdl-button--raised mdl-button--colored"
								onClick={this.props.onBack}
								type="button">
								<ArrowBackIcon />
								{t('buttons.back')}
							</button>
							<button
								className="mdl-button mdl-js-button mdl-button--raised mdl-button--colored"
								disabled={this.state._disableContinueButton}
								onClick={this.onSubmitHandler}
								type="button">
								{t('buttons.continue')}
								<ArrowForwardIcon />
							</button>
						</div>
					</div>
				</div>
				{this.props.isLoading ? <Loader /> : ''}
			</section>
		);
	}
}

export default hot(module)(withStyles(styles)(withTranslation()(EditContactForm)));
